import getLocalSettingsProxy from '../../getLocalSettingsProxy';

/**
 * @method getBookLocationPropertiesFromLocalSettings
 * @param {Book} book - an instance of Book
 * @returns {Object} object with a timestamp, documentIndex, and cfi
 *                   or null if a timestamp is not set
 */
const getBookLocationPropertiesFromLocalSettings = (book) => {
  if (!book) {
    throw new Error('An instance of Book is required.');
  }

  const localSettings = getLocalSettingsProxy(book.pk);

  const { timestamp, documentIndex, cfi } =
    localSettings.mostRecentBookLocation;

  if (!timestamp) {
    return null;
  }

  return {
    timestamp: parseInt(timestamp),
    documentIndex: parseInt(documentIndex) ?? 0,
    cfi: cfi ?? undefined,
  };
};

export default getBookLocationPropertiesFromLocalSettings;
